// TODO: this should be in some lib
export enum Scopes {
  employees_all = 'employees:*',
  employees_associated = 'employees:associated',
  expenses_approver = 'expenses:approver',
  expenses_notifications = 'expenses:notifications',
  payroll_all = 'payroll:*',
  finance_all = 'finance:*',
}

export type AllowedProduct = 'EOR' | 'Contractor';

export enum CompanyManagerDepartmentEnum {
  Management = 'Management',
  Finance = 'Finance',
  HumanResources = 'Human Resources',
  Marketing = 'Marketing',
  Sales = 'Sales',
  Operations = 'Operations',
  Legal = 'Legal',
  Engineering = 'Engineering',
  Product = 'Product',
  Design = 'Design',
  Other = 'Other',
}

export type BaseCompanyManager = {
  id: string;
  name?: string | null;
  department?: CompanyManagerDepartmentEnum | null;
  jobTitle?: string | null;
  scopes?: Scopes[];
};

export type CompanyEmailTemplate =
  | 'PLATFORM_INVITE_MANAGER_AUTOMATED_COMPANY_CREATION'
  | 'CO_FOUNDERS_WELCOME';

export type CompanyEmail = {
  id: string;
  attachments?: string[];
  copiedRecipient?: string[];
  recipient: string;
  sender: string;
  templateName: CompanyEmailTemplate;
  timestamp: string;
};

// Model when fetching the list of companies
export type BaseCompany = {
  id: string;
  name: string;
  externalId?: string | null;
  countryOfRegistration?: string | null;
  onboardingStage?: string | null;
  invoicingEmail?: string | null;
  createdAt?: string | null;
  createdBy?: string | null;
  updatedAt?: string | null;
  updatedBy?: string | null;
  adminNotes?: string | null;
  needsManagerReview?: boolean | null;
  isVATExempt?: boolean;
  salesforceAccountId?: string | null;
  fxConversionPercent?: string | null;
  benefitsPercentage?: number | null;
  identifiers?: {
    companyNumber?: string;
    vatNumber?: string;
  } | null;
};

// Model when fetching the details of a company
export type Company = BaseCompany & {
  registeredAddress?: {
    addressLine1?: string | null;
    addressLine2?: string | null;
    addressLine3?: string | null;
    city?: string | null;
    postalCode?: string | null;
    state?: string | null;
    country?: string | null;
  } | null;
  primaryContact?: {
    name?: string | null;
    phoneNumber?: string | null;
    email?: string | null;
  } | null;
  newBusinessOpportunity?: {
    id?: string | null;
    name?: string | null;
  } | null;
  salaryPrepayment?: {
    terms?: number | null;
    multiplier?: number | string | null;
  } | null;
  customerSuccessManager?: {
    email: string;
    firstName: string;
    lastName: string;
  } | null;
  settings?: {
    disableContractAutomation?: boolean | null;
    enforceMFA?: boolean | null;
  } | null;
  enabledProducts?: AllowedProduct[] | null;
  latePayment?: {
    amount?: number | null;
    interestMargin?: number | null;
  } | null;
  emailHistory?: CompanyEmail[];
  managers?: BaseCompanyManager[];
};

export type CompanyAvailableProducts = Record<AllowedProduct, boolean>;
